import { TechnologyDataInterface } from '@vendasta/snapshot';

export class TechnologyData implements TechnologyDataInterface {
  technologyIds: string[];

  constructor(data?: TechnologyDataInterface) {
    this.technologyIds = data?.technologyIds || [];
  }
}
